import { useEffect } from 'react';
import { applyPageSeo } from '../lib/applyPageSeo';

export const usePageSeo = (pathname, hash = '') => {
  // applyPageSeo is a module import, not a render-created function.
  useEffect(() => { applyPageSeo(pathname); }, [pathname]);
  useEffect(() => {
    // Resolve the target after the route commits; it is local to this effect.
    const target = hash && document.getElementById(hash.slice(1));
    if (target) target.scrollIntoView({ behavior: 'instant' });
    else window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);
};